import React, {useEffect, useState} from "react";
import TableList from "../../../component/TableList/TableList";
import {normalizeTimestemp} from "../../../utils/normalizeTimestemp";
import AntecipacaoActions from "./AntecipacaoActions";
import FilterAntecipacao from "./FilterAntecipacao";
import PopupPreviewAntecipacao from "./Preview/PopupPreviewAntecipacao";
import PopupManageFees from "./Preview/PopupManageFees";
import axios from "axios";
import {useUser} from "../../../auth/AuthProvider";

export default function AntecipacaoList({
                                      baseUrl, loadData,
                                      setLoadData, size, page,
                                      setTotalPages, setTotalElements,
                                      sort, setSort, updateCode, setPage
                                  }) {

    const [data, setData] = useState([])
    const [error, setError] = useState(false)
    const [filter, setFilter] = useState({})
    const {user} = useUser()

    const titles = [
        'Parcela',
        'Data da antecipação',
        'Antecipante',
        'Fundo',
        'Valor Antecipado',
        'Status'
    ]

    const [taxaAdmin, setTaxaAdmin] = useState("");
    const [taxaAntecipacao, setTaxaAntecipacao] = useState("");

    useEffect(() => {

        axios.defaults.headers.common['Authorization'] = `Bearer ${user?.token}`;
        if (loadData) {
            axios.get(baseUrl + '/fees')
                .then(function (response) {
                    console.log("searching data")
                    setTaxaAdmin(response.data.adminFee)
                    setTaxaAntecipacao(response.data.anticipationFee)
                    console.log({response})
                }).catch(function (errorReceived) {
                // aqui temos acesso ao erro, quando alguma coisa inesperada acontece:
                console.log(errorReceived);
            })
        }

    }, [loadData]);


    return (
        <>
            <FilterAntecipacao filter={filter} setFilter={setFilter} setLoadData={setLoadData} setPage={setPage}/>
            <PopupManageFees
                taxaAdmin={taxaAdmin} setTaxaAdmin={setTaxaAdmin}
                taxaAntecipacao={taxaAntecipacao} setTaxaAntecipacao={setTaxaAntecipacao}
                baseUrl={baseUrl+'/fees'}
            />
            <PopupPreviewAntecipacao
                taxaAdmin={taxaAdmin}
                taxaAntecipacao={taxaAntecipacao}
            />
            <TableList
                titles={titles} baseUrl={baseUrl + '/list'}
                page={page} sort={sort} size={size}
                loadData={loadData}
                setTotalPages={setTotalPages} setTotalElements={setTotalElements}
                setData={setData} setLoadData={setLoadData} filter={filter}
                error={error} setError={setError} isFilterByUser={true}
            >
                {data.map((item) =>
                    <tr key={item.id}>
                        <td>{item.parcelaNumero}</td>
                        <td>{normalizeTimestemp(item.dataAntecipacao)}</td>
                        <td>{item.nomeAntecipante}</td>
                        <td>{item.fundo}</td>
                        <td>{item.valor}</td>
                        <td>{item.status ? item.status : ''}</td>
                        <td><AntecipacaoActions item={item} setLoadData={setLoadData} baseUrl={baseUrl}/></td>
                    </tr>
                )}
            </TableList>
        </>
    )
}